import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "313",
  "slug": "spot-pakistan-from-satellite-imagery",
  "title": "How to Recognise Pakistan in Satellite Images",
  "excerpt": "The Indus system connects the northern mountains with the irrigated plains and the Arabian Sea.",
  "date": "2026-05-14",
  "category": "Geography",
  "image": "/blog-images/pakistan.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Indus system connects the northern mountains with the irrigated plains and the Arabian Sea. In a regional image, compare the cultivated corridor with the drier land beside it. The river bends and the position of its delta provide anchors that a patch of green fields cannot."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Agricultural landscapes continue across the border into India, while arid mountains extend toward Iran and Afghanistan. Avoid trying to infer nationality from field size or canal density alone. Trace the river network and locate a named city or mountain range. The composite has no political boundaries, including in disputed areas."
    }
  ],
  "imageAlt": "Pakistan regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
